import React, { useState, useEffect, useMemo } from "react";
import debounce from "lodash.debounce";
import { Table, Card, Skeleton, Row, Col, Image, Pagination } from "antd";
import { useLazyQuery } from "@apollo/client";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import Search from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import moment from "moment";
import "moment/locale/es";
import localStorageService from "../../../../services/localStorageService";
import { getColumnSearchProps, getColumnSearchPropsText } from "./UseCases";
import {
  fetchCompletedRoutes,
  fetchtelemetry,
  countRegisterRoute,
  countRegisterRouteNumber,
  CountFilterPlaniCompleteRoutes,
  FilterPlaniCompleteRoutes,
  FilterDetailsCompleteRoutes,
  fetchCompletedRoutesDetails,
  CountFilterCompleteRoutesDetails,
  fetchOrderTableExtras,
  FilterDetailsByOrderNumber,
  FilterDetailsByConsecutiveBurden,
  FilterDetailsByConsecutiveSaleOrder,
} from "../../queries/routesBatch";
import { DeliveryRoute } from "./DeliveryRoute";
import "../styles/styles.css";
import * as geolib from "geolib";

export const CompletedRoutesScreen = (props) => {
  const [selectedWarehouse, setSelectedWarehouse] = useState(
    JSON.parse(localStorageService.get("userDistributionsCenters"))
  );

  const [telemetryUserVehicle, setTelemetryUserVehicle] = useState(
    "00000000-0000-0000-0000-000000000000"
  );
  const [
    telemetryOrderTablestartDateTime,
    setTelemetryOrderTablestartDateTime,
  ] = useState("");
  const [telemetryOrderTableEndDateTime, setTelemetryOrderTableEndDateTime] =
    useState("");
  const [visibleTelemetry, setVisibleTelemetry] = useState(false);
  const [tableResponsive, setTableResponsive] = useState(false);

  const [searchFilterPlanificador, setSearchFilterPlanificador] = useState("");
  const [searchFilterConsecutivo, setSearchFilterConsecutivo] = useState("");
  const [searchFilterCarga, setSearchFilterCarga] = useState("");
  const [searchFilterOVTRN, setSearchFilterOVTRN] = useState("");

  const [loading, setLoading] = useState(false);

  const [routesBatch, setRoutesBatch] = useState([]);
  const [filterRoutesBatch, setFilterRoutesBatch] = useState([]);
  const [filterRoutesBatchDetails, setFilterRoutesBatchDetails] = useState([]);

  const [countFilterRouteComplete, setCountFilterRouteComplete] = useState(0);
  const [countFilterRouteCompleteDetails, setCountFilterRouteCompleteDetails] =
    useState(0);

  const [details, setDetails] = useState([]);
  const [filterDetails, setFilterDetails] = useState([]);
  const [selectedOrderTable, setSelectedOrderTable] = useState({});

  const [lines, setLines] = useState([]);

  const [filter, setFilter] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(30);
  const [currentPageSecond, setCurrentPageSecond] = useState(1);
  const [pageSizeSecond, setPageSizeSecond] = useState(10);
  const [currentPageTree, setCurrentPageTree] = useState(1);
  const [pageSizeTree, setPageSizeTree] = useState(10);
  const [polylines, setPolylines] = useState([]);
  const [selectedBatchKey, setSelectedBatchKey] = useState(null);

  const [activeHeader, setActiveHeader] = useState(false);

  const [getByOrderNumber] = useLazyQuery(FilterDetailsByOrderNumber, {
    fetchPolicy: "no-cache",
  });
  const [getByBurden] = useLazyQuery(FilterDetailsByConsecutiveBurden, {
    fetchPolicy: "no-cache",
  });
  const [getBySaleOrder] = useLazyQuery(FilterDetailsByConsecutiveSaleOrder, {
    fetchPolicy: "no-cache",
  });

  const safeTrim = (v) => (v ?? "").trim();

  // Queries
  const [getCompletedRoutes, dataCompletedRoutes] = useLazyQuery(
    countRegisterRoute,
    {
      variables: {
        distributionCenterId:
          selectedWarehouse?.length > 0
            ? selectedWarehouse
            : ["00000000-0000-0000-0000-000000000000"],
      },
      fetchPolicy: "no-cache",
    }
  );

  const [getCompletedRoutesNumber, dataCompletedRoutesNumber] = useLazyQuery(
    countRegisterRouteNumber,
    {
      variables: {
        distributionCenterId:
          selectedWarehouse?.length > 0
            ? selectedWarehouse
            : ["00000000-0000-0000-0000-000000000000"],
      },
      fetchPolicy: "no-cache",
    }
  );

  const [getPagineRoute] = useLazyQuery(fetchCompletedRoutes, {
    fetchPolicy: "no-cache",
  });
  const [getFilterDetailsCompleteRoutes] = useLazyQuery(
    FilterDetailsCompleteRoutes,
    {
      fetchPolicy: "no-cache",
    }
  );
  const [getFilterCompleteRoute] = useLazyQuery(FilterPlaniCompleteRoutes, {
    fetchPolicy: "no-cache",
  });
  const [getCountCompleteRoute] = useLazyQuery(CountFilterPlaniCompleteRoutes, {
    fetchPolicy: "no-cache",
  });
  const [getCountCompleteRouteDetails] = useLazyQuery(
    CountFilterCompleteRoutesDetails,
    {
      fetchPolicy: "no-cache",
    }
  );
  const [getFuncCompletedRoutesDetails] = useLazyQuery(
    fetchCompletedRoutesDetails,
    {
      fetchPolicy: "no-cache",
    }
  );
  const [getTelemetry, dataTelemetry] = useLazyQuery(fetchtelemetry, {
    fetchPolicy: "no-cache",
  });

  // details by batch + extras on-demand
  const [getDetailsByBatch, detailsByBatch] = useLazyQuery(
    fetchCompletedRoutesDetails,
    {
      fetchPolicy: "no-cache",
    }
  );
  const [getOrderTableExtras] = useLazyQuery(fetchOrderTableExtras, {
    fetchPolicy: "no-cache",
  });

  // Helpers
  const safeVal = (v) => (v && v.trim().length ? v.trim() : null);

  const reset = () => {
    setFilterDetails([]);
    setDetails([]);
    setSelectedOrderTable({});
    setLines([]);
    setTableResponsive(false);
    setVisibleTelemetry(false);
  };

  // Telemetry trigger
  useEffect(() => {
    if (
      telemetryUserVehicle?.length > 0 &&
      telemetryOrderTablestartDateTime?.length > 0 &&
      telemetryOrderTableEndDateTime?.length > 0
    ) {
      const telemetryOrderTableStartDateTimeUTC = moment(
        moment.utc(telemetryOrderTablestartDateTime)
      )
        .add(5, "hours")
        .format("YYYY-MM-DDTHH:mm:ss+00:00");

      const telemetryOrderTableEndDateTimeUTC = moment(
        moment.utc(telemetryOrderTableEndDateTime)
      )
        .add(5, "hours")
        .format("YYYY-MM-DDTHH:mm:ss+00:00");

      getTelemetry({
        variables: {
          userVehicleId: telemetryUserVehicle,
          startDateTime: telemetryOrderTableStartDateTimeUTC,
          endDateTime: telemetryOrderTableEndDateTimeUTC,
        },
      });
    }
  }, [
    telemetryUserVehicle,
    telemetryOrderTablestartDateTime,
    telemetryOrderTableEndDateTime,
    getTelemetry,
  ]);

  // Telemetry derived values
  useEffect(() => {
    if (dataTelemetry.data?.telemetry?.length > 0) {
      setVisibleTelemetry(true);
    } else {
      setVisibleTelemetry(false);
    }
  }, [dataTelemetry.data, dataTelemetry.loading]);

  // Warehouses
  useEffect(() => {
    const warehouses = JSON.parse(
      localStorageService.get("selectedWarehouses")
    )?.warehouses;
    setSelectedWarehouse(warehouses);
  }, [props.flag]);

  // Initial loads
  useEffect(() => {
    getCompletedRoutes();
    getCompletedRoutesNumber();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Safe read from localStorage
  useEffect(() => {
    const raw = localStorage.getItem("searchTarget") || "";
    setFilter(raw);
    if (raw.length === 0) {
      setTelemetryUserVehicle([]);
    }
  }, [props.flag]);

  // Page 1 initial
  useEffect(() => {
    completeRoutesPagination(30, 0);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // When batch details arrive
  useEffect(() => {
    if (detailsByBatch.data?.routes?.length) {
      setDetails(detailsByBatch.data.routes);
      setTelemetryUserVehicle(
        detailsByBatch.data.routes[0]?.user?.userVehicle?.id ||
          "00000000-0000-0000-0000-000000000000"
      );
      setActiveHeader(true);
    } else {
      setDetails([]);
    }
  }, [detailsByBatch.data]);

  const completeRoutesPagination = async (limit, offset) => {
    setLoading(true);
    const res = await getPagineRoute({
      variables: {
        distributionCenterId:
          selectedWarehouse?.length > 0
            ? selectedWarehouse
            : ["00000000-0000-0000-0000-000000000000"],
        limit,
        offset: offset * limit,
      },
    });

    const list = res?.data?.routesBatch ?? [];
    if (list.length > 0) {
      const mapped = list.map((item) => {
        const {
          id,
          batch,
          createdAt,
          startDateRoute,
          endDateRoute,
          routes,
          licencePlate,
          user,
        } = item;
        return {
          id,
          batch,
          createdAt,
          startDateRoute,
          endDateRoute,
          routes,
          driverName: user?.displayName || "",
          planner: routes?.[0]?.createByUser?.displayName || "",
          licencePlate,
          loadShipConfirmUTCDateTime:
            routes?.[0]?.orderTable?.loadShipConfirmUTCDateTime || "",
        };
      });
      setRoutesBatch(mapped);
    } else {
      setRoutesBatch([]);
    }
    setFilterRoutesBatch([]);
    setFilterRoutesBatchDetails([]);
    setFilterDetails([]);
    setLines([]);
    setLoading(false);
  };

  // Row selections
  const rowSelectionHeader = {
    // OJO: antd pasa primero las keys y luego las filas
    onChange: async (selectedRowKeys, selectedRows) => {
      const key = selectedRowKeys?.[0];
      const row = selectedRows?.[0];
      if (!row) {
        setSelectedBatchKey(null);
        return;
      }

      // ► actualiza la selección controlada para que se pinte
      setSelectedBatchKey(key ?? row.batch);

      setLoading(true);
      await getDetailsByBatch({ variables: { batch: row.batch } });
      setLoading(false);
    },
  };

  const rowSelectionDetails = {
    onChange: async (_keys, rows) => {
      const route = rows?.[0];
      if (!route) return;

      setTableResponsive(true);
      setPolylines(route.polylines || []);
      setTelemetryOrderTablestartDateTime(route.startDateTime || "");
      setTelemetryOrderTableEndDateTime(route.endDateTime || "");

      // ► SINCRONIZA selección en el header
      if (route.batch) {
        setSelectedBatchKey(route.batch);
      }

      // ► Asegura telemetría también aquí (cuando viene de filtros por UM/Factura/OV)
      const vehId = route?.user?.userVehicle?.id;
      if (vehId) {
        setTelemetryUserVehicle(vehId);
      }

      if (route.orderTable?.id) {
        const { data } = await getOrderTableExtras({
          variables: { orderTableId: route.orderTable.id },
        });
        const ot = data?.ordersTable_by_pk;
        setSelectedOrderTable({
          ...route.orderTable,
          evidences: ot?.evidences ?? [],
        });
        setLines(
          (ot?.ordersLines ?? []).map(
            ({
              id,
              productNumber,
              productName,
              initialQuantity,
              summationQuantity,
            }) => ({
              id,
              productNumber,
              productName,
              initialQuantity,
              summationQuantity,
            })
          )
        );
      } else {
        setSelectedOrderTable({});
        setLines([]);
      }
    },
  };

  // Pagination handlers
  const handlePageChange = (page, pageSize) => {
    if (filterRoutesBatch?.length > 0) {
      handlsavePlanificador(searchFilterPlanificador, pageSize, page);
      setFilterRoutesBatch([]);
    } else if (routesBatch?.length > 0) {
      completeRoutesPagination(pageSize, page);
      setRoutesBatch([]);
    }
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageChangeSecond = (page, pageSize) => {
    setCurrentPageSecond(page);
    setPageSizeSecond(pageSize);
  };
  const handlePageChangeTree = (page, pageSize) => {
    setCurrentPageTree(page);
    setPageSizeTree(pageSize);
  };

  // Telemetry summary
  const telemetry = () => {
    const series = dataTelemetry.data?.telemetry;
    if (!series || series.length === 0)
      return "No hay suficientes datos para calcular.";

    let totalDistance = 0;
    let totalSpeed = 0;
    let count = 0;

    let lastData = series[0];
    for (let i = 1; i < series.length; i++) {
      const currentData = series[i];
      const distance = geolib.getDistance(
        { latitude: lastData.latitude, longitude: lastData.longitude },
        { latitude: currentData.latitude, longitude: currentData.longitude }
      );
      if (distance > 10) {
        const time = moment(currentData.timestamp).diff(
          moment(lastData.timestamp),
          "seconds"
        );
        if (time > 0) {
          const speed = (distance / time) * 3.6;
          totalSpeed += speed;
          totalDistance += distance;
          count++;
        }
      }
      lastData = currentData;
    }
    const averageSpeed = count > 0 ? totalSpeed / count : 0;
    return `Velocidad promedio: ${averageSpeed.toFixed(
      2
    )} Km/h - Distancia recorrida: ${totalDistance} Mts`;
  };

  // Search inputs
  const debouncedPlanificador = useMemo(
    () => debounce((v) => handlsavePlanificador(v, 30, 0), 400),
    [] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const textFieldEventPlanificador = (ev) => {
    const val = ev.target.value;
    setSearchFilterPlanificador(val);
    // Si quieres auto-search al tipear:
    // debouncedPlanificador(val);
  };
  const textFieldEventConsecutivo = (ev) =>
    setSearchFilterConsecutivo(ev.target.value);
  const textFieldEventCarga = (ev) => setSearchFilterCarga(ev.target.value);
  const textFieldEventOVTRN = (ev) => setSearchFilterOVTRN(ev.target.value);

  // Actions
  let countFilterCompleteRoute;
  const handlsavePlanificador = async (search, limit, offset) => {
    const val = safeVal(search);
    if (!val) {
      completeRoutesPagination(30, 0);
      return;
    }
    setLoading(true);
    const responseFilterCompleteRoute = await getFilterCompleteRoute({
      variables: {
        distributionCenterId:
          selectedWarehouse?.length > 0
            ? selectedWarehouse
            : ["00000000-0000-0000-0000-000000000000"],
        displayName: val,
        limit,
        offset: offset * limit,
      },
    });

    const list = responseFilterCompleteRoute?.data?.routesBatch ?? [];
    if (list.length > 0) {
      countFilterCompleteRoute = await getCountCompleteRoute({
        variables: {
          distributionCenterId:
            selectedWarehouse?.length > 0
              ? selectedWarehouse
              : ["00000000-0000-0000-0000-000000000000"],
          displayName: val,
        },
      });
      setCountFilterRouteComplete(
        countFilterCompleteRoute?.data?.routesBatch_aggregate?.aggregate
          ?.count || 0
      );

      const mapped = list.map((item) => {
        const {
          id,
          batch,
          createdAt,
          startDateRoute,
          endDateRoute,
          routes,
          licencePlate,
          user,
        } = item;
        return {
          id,
          batch,
          createdAt,
          startDateRoute,
          endDateRoute,
          routes,
          driverName: user?.displayName || "",
          planner: routes?.[0]?.createByUser?.displayName || "",
          licencePlate,
          loadShipConfirmUTCDateTime:
            routes?.[0]?.orderTable?.loadShipConfirmUTCDateTime || "",
        };
      });
      setFilterRoutesBatch(mapped);
    } else {
      setFilterRoutesBatch([]);
      setCountFilterRouteComplete(0);
    }
    setRoutesBatch([]);
    setFilterRoutesBatchDetails([]);
    setLoading(false);
  };

  let countFilterCompleteRouteDetails;
  const funcCompletedRoutesDetails = async (search, limit, offset) => {
    setLoading(true);
    const res = await getFuncCompletedRoutesDetails({
      variables: {
        distributionCenterId:
          selectedWarehouse?.length > 0
            ? selectedWarehouse
            : ["00000000-0000-0000-0000-000000000000"],
        batch: search.batch,
        limit,
        offset: offset * limit,
      },
    });

    const list = res?.data?.routesBatch ?? [];
    if (list.length > 0) {
      countFilterCompleteRouteDetails = await getCountCompleteRouteDetails({
        variables: {
          distributionCenterId:
            selectedWarehouse?.length > 0
              ? selectedWarehouse
              : ["00000000-0000-0000-0000-000000000000"],
          batch: search.batch,
        },
      });
      setCountFilterRouteCompleteDetails(
        countFilterCompleteRouteDetails?.data?.routesBatch_aggregate?.aggregate
          ?.count || 0
      );

      const mapped = list.map((item) => {
        const {
          id,
          batch,
          createdAt,
          startDateRoute,
          endDateRoute,
          routes,
          licencePlate,
          user,
        } = item;
        return {
          id,
          batch,
          createdAt,
          startDateRoute,
          endDateRoute,
          routes,
          driverName: user?.displayName || "",
          planner: routes?.[0]?.createByUser?.displayName || "",
          licencePlate,
          loadShipConfirmUTCDateTime:
            routes?.[0]?.orderTable?.loadShipConfirmUTCDateTime || "",
        };
      });
      setFilterRoutesBatchDetails(mapped);
    } else {
      setFilterRoutesBatchDetails([]);
      setCountFilterRouteCompleteDetails(0);
    }
    setFilterRoutesBatch([]);
    setRoutesBatch([]);
    setLoading(false);
  };

  const handlsaveConsecutivo = async (search, limit, offset) => {
    const val = safeTrim(search);
    if (!val) {
      reset();
      return;
    }

    setLoading(true);
    const { data } = await getByOrderNumber({
      variables: {
        distributionCenterId: selectedWarehouse?.length
          ? selectedWarehouse
          : ["00000000-0000-0000-0000-000000000000"],
        orderNumber: val,
        limit,
        offset: offset * limit,
      },
    });
    setLoading(false);

    // Detalles (tabla del medio)
    const batchNode = data?.routesBatch?.[0];
    const routesOfBatch = batchNode?.routes ?? [];
    setFilterDetails(routesOfBatch);
    setDetails([]);

    // ► Header: muestra SOLO ese batch y selecciónalo
    if (batchNode) {
      const {
        id,
        batch,
        createdAt,
        startDateRoute,
        endDateRoute,
        routes,
        licencePlate,
        user,
      } = batchNode;

      const headerRow = {
        id,
        batch,
        createdAt,
        startDateRoute,
        endDateRoute,
        routes,
        driverName: user?.displayName || "",
        planner: routes?.[0]?.createByUser?.displayName || "",
        licencePlate,
        loadShipConfirmUTCDateTime:
          routes?.[0]?.orderTable?.loadShipConfirmUTCDateTime || "",
      };

      // limpia otras fuentes y deja este batch como dataset del header
      setRoutesBatch([]);
      setFilterRoutesBatch([]);
      setFilterRoutesBatchDetails([headerRow]);

      // marca seleccionado el batch en el header
      setSelectedBatchKey(batch);

      // opcional: si quieres ya precargar el panel de detalles por batch desde el server (no necesario porque ya tienes routesOfBatch):
      // await getDetailsByBatch({ variables: { batch } });
    } else {
      // si no hay resultados, vacía header y selección
      setFilterRoutesBatchDetails([]);
      setSelectedBatchKey(null);
    }
  };

  const handlsaveCarga = async (search, limit, offset) => {
    const val = safeTrim(search);
    if (!val) {
      completeRoutesPagination(30, 0);
      setSelectedOrderTable({});
      setTableResponsive(false);
      setVisibleTelemetry(false);
      setSelectedBatchKey(null);
      return;
    }

    setLoading(true);
    const { data } = await getByBurden({
      variables: {
        distributionCenterId: selectedWarehouse?.length
          ? selectedWarehouse
          : ["00000000-0000-0000-0000-000000000000"],
        consecutiveBurden: val,
        limit,
        offset: offset * limit,
      },
    });
    setLoading(false);

    const batchNode = data?.routesBatch?.[0];
    setFilterDetails(batchNode?.routes ?? []);
    setDetails([]);

    if (batchNode) {
      const {
        id,
        batch,
        createdAt,
        startDateRoute,
        endDateRoute,
        routes,
        licencePlate,
        user,
      } = batchNode;
      const headerRow = {
        id,
        batch,
        createdAt,
        startDateRoute,
        endDateRoute,
        routes,
        driverName: user?.displayName || "",
        planner: routes?.[0]?.createByUser?.displayName || "",
        licencePlate,
        loadShipConfirmUTCDateTime:
          routes?.[0]?.orderTable?.loadShipConfirmUTCDateTime || "",
      };
      setRoutesBatch([]);
      setFilterRoutesBatch([]);
      setFilterRoutesBatchDetails([headerRow]);
      setSelectedBatchKey(batch);
    } else {
      setFilterRoutesBatchDetails([]);
      setSelectedBatchKey(null);
    }
  };

  const handlsaveOVTRN = async (search, limit, offset) => {
    const val = safeTrim(search);
    if (!val) {
      completeRoutesPagination(30, 0);
      setSelectedOrderTable();
      setTableResponsive(false);
      setVisibleTelemetry(false);
      return;
    }

    setLoading(true);
    const { data } = await getBySaleOrder({
      variables: {
        distributionCenterId: selectedWarehouse?.length
          ? selectedWarehouse
          : ["00000000-0000-0000-0000-000000000000"],
        consecutiveSaleOrder: val,
        limit,
        offset: offset * limit,
      },
    });
    setLoading(false);
    setFilterDetails(data?.routesBatch?.[0]?.routes ?? []);
    setDetails([]);
  };

  // Columns
  const headerColumns = [
    {
      key: "loadShipConfirmUTCDateTime",
      dataIndex: "loadShipConfirmUTCDateTime",
      title: "Fecha y Hora de Confirmacion de Envio",
      className: "table-column",
      align: "center",
      render: (value, record) => {
        let date = moment.utc(value);
        let localTime = moment(date).local().format("DD/MM/YYYY h:mm a");
        if (localTime === "Fecha inválida") {
          let fallbackDate = moment.utc(record.createdAt);
          let fallbackLocalTime = moment(fallbackDate)
            .local()
            .format("DD/MM/YYYY h:mm a");
          return (
            <span>
              {fallbackLocalTime === "Fecha inválida"
                ? "N/D"
                : fallbackLocalTime}
            </span>
          );
        }
        return <span>{localTime}</span>;
      },
      ...getColumnSearchProps("loadShipConfirmUTCDateTime"),
    },
    {
      key: "createdAt",
      dataIndex: "createdAt",
      title: "Creación UM",
      className: "table-column",
      align: "center",
      render: (value) => {
        let date = moment.utc(value);
        let localTime = moment(date).local().format("DD/MM/YYYY h:mm a");
        return <span>{localTime}</span>;
      },
      ...getColumnSearchProps("createdAt"),
    },
    {
      key: "planner",
      dataIndex: "planner",
      title: "Planificador",
      className: "table-column",
      align: "center",
      render: (value) => <span>{value}</span>,
      ...getColumnSearchPropsText("Planificador", "displayName"),
    },
    {
      key: "driverName",
      dataIndex: "driverName",
      className: "table-column",
      title: "Conductor",
      render: (value) => <span>{value}</span>,
      ...getColumnSearchPropsText("Conductor", "driverName"),
    },
    {
      key: "startDateRoute",
      dataIndex: "startDateRoute",
      title: "Inicio de Ruta",
      className: "table-column",
      align: "center",
      render: (value) => {
        let date = moment.utc(value);
        let localTime = moment(date).format("DD/MM/YYYY h:mm a");
        return <span>{localTime}</span>;
      },
      ...getColumnSearchProps("startDateRoute"),
    },
    {
      key: "endDateRoute",
      dataIndex: "endDateRoute",
      title: "Fin de Ruta",
      className: "table-column",
      align: "center",
      render: (value) => {
        let date = moment.utc(value);
        let localTime = moment(date).format("DD/MM/YYYY h:mm a");
        return <span>{localTime}</span>;
      },
      ...getColumnSearchProps("endDateRoute"),
    },
  ];

  const detailsColumns = [
    {
      key: "orderNumber",
      dataIndex: "orderTable",
      className: "table-column",
      title: "Orden",
      render: (record) => <span>{record?.orderNumber}</span>,
      ...getColumnSearchPropsText("Orden", "orderTable.orderNumber"),
    },
    {
      key: "type",
      dataIndex: "orderTable",
      title: "Tipo",
      className: "table-column",
      align: "center",
      render: (record) => (
        <span>
          {record?.type === "Envío" || record?.type === "delivery"
            ? "Envío"
            : record?.type === "pickup"
            ? "Recogida"
            : record?.type === "customService"
            ? "Servicio Personalizado"
            : record?.type === "warehousesTransfer"
            ? "Traslado entre Bodegas"
            : ""}
        </span>
      ),
    },
    {
      key: "custFullName",
      dataIndex: "orderTable",
      className: "table-column",
      title: "Cliente",
      render: (record) => <span>{record?.custFullName}</span>,
    },
    {
      key: "status",
      dataIndex: "status",
      title: "Estado",
      className: "table-column",
      render: (value) => {
        let status = "";
        switch (value) {
          case "none":
          case "start":
            status = "Ninguno";
            break;
          case "started":
            status = "En reparto";
            break;
          case "delivered":
            status = "Completamente Entregado";
            break;
          case "undelivered":
            status = "Devuelto";
            break;
          case "partial_delivered":
            status = "Con Novedad";
            break;
          case "rescheduled_delivery":
            status = "Entrega Reprogramada";
            break;
          default:
            status = "Ninguno";
        }
        return status;
      },
    },
    {
      key: "description",
      dataIndex: "description",
      title: "Motivo",
      className: "table-column",
      render: (_, record) => <span>{record?.reason?.description}</span>,
    },
    {
      key: "consecutiveBurden",
      dataIndex: "orderTable",
      title: "Carga",
      className: "table-column",
      align: "center",
      render: (record) => <span>{record?.consecutiveBurden}</span>,
    },
    {
      key: "consecutiveBill",
      dataIndex: "orderTable",
      title: "Factura",
      className: "table-column",
      align: "center",
      render: (record) => <span>{record?.consecutiveBill}</span>,
    },
    {
      key: "consecutiveRemission",
      dataIndex: "orderTable",
      title: "Remisión",
      className: "table-column",
      align: "center",
      render: (record) => <span>{record?.consecutiveRemission}</span>,
    },
    {
      key: "consecutiveSaleOrder",
      dataIndex: "orderTable",
      title: "Orden/TRN",
      className: "table-column",
      align: "center",
      render: (record) => <span>{record?.consecutiveSaleOrder}</span>,
    },
    {
      key: "receivedPerson",
      dataIndex: "receivedPerson",
      title: "Nombre",
      className: "table-column",
      align: "center",
      render: (value) => <span>{value}</span>,
    },
    {
      key: "receivedDocument",
      dataIndex: "receivedDocument",
      title: "Documento",
      className: "table-column",
      align: "center",
      render: (value) => <span>{value}</span>,
    },
    {
      key: "notes",
      dataIndex: "orderTable",
      className: "table-column",
      title: "Notas",
      render: (record) => <span>{record?.notes}</span>,
    },
    {
      key: "paymentMethod",
      dataIndex: "orderTable",
      title: "Metodo de Pago",
      className: "table-column",
      align: "center",
      render: (record) => <span>{record?.paymentMethod}</span>,
    },
    {
      key: "state",
      dataIndex: "orderTable",
      title: "Departamento",
      className: "table-column",
      align: "center",
      render: (record) => <span>{record?.state}</span>,
    },
    {
      key: "city",
      dataIndex: "orderTable",
      title: "Ciudad",
      className: "table-column",
      align: "center",
      render: (record) => <span>{record?.city}</span>,
    },
    {
      key: "address",
      dataIndex: "orderTable",
      title: "Dirección",
      className: "table-column",
      align: "center",
      render: (record) => <span>{record?.address}</span>,
    },
    {
      key: "distanceText",
      dataIndex: "distanceText",
      title: "Distancia",
      className: "table-column",
      align: "center",
    },
    {
      key: "durationText",
      dataIndex: "durationText",
      title: "Duración",
      className: "table-column",
    },
    {
      key: "expectedDeliveryStartTime",
      dataIndex: "orderTable",
      title: "Fecha inicio compromiso de entrega ",
      className: "table-column",
      align: "center",
      render: (record) => {
        if (!record?.expectedDeliveryStartTime) return "N/D";
        let date = moment.utc(record.expectedDeliveryStartTime);
        let localTime = moment(date)
          .subtract(5, "hours")
          .format("DD/MM/YYYY h:mm a");
        return (
          <span>
            {localTime === "01/01/1900 12:00 am" ||
            record.expectedDeliveryStartTime === "1900-01-01T00:00:00Z"
              ? "N/D"
              : localTime}
          </span>
        );
      },
    },
    {
      key: "expectedDeliveryEndTime",
      dataIndex: "orderTable",
      title: "Fecha fin compromiso de entrega",
      className: "table-column",
      align: "center",
      render: (record) => {
        if (!record?.expectedDeliveryEndTime) return "N/D";
        let date = moment.utc(record.expectedDeliveryEndTime);
        let localTime = moment(date)
          .subtract(5, "hours")
          .format("DD/MM/YYYY h:mm a");
        return (
          <span>
            {localTime === "01/01/1900 12:00 am" ||
            record.expectedDeliveryEndTime === "1900-01-01T00:00:00Z"
              ? "N/D"
              : localTime}
          </span>
        );
      },
    },
    {
      key: "startDateTime",
      dataIndex: "startDateTime",
      title: "Inicio",
      className: "table-column",
      align: "center",
      render: (value) => {
        if (!value) return "N/D";
        let date = moment.utc(value);
        let localTime = moment(date).format("DD/MM/YYYY h:mm a");
        return <span>{localTime}</span>;
      },
    },
    {
      key: "endDateTime",
      dataIndex: "endDateTime",
      title: "Fin",
      className: "table-column",
      align: "center",
      render: (value) => {
        if (!value) return "N/D";
        let date = moment.utc(value);
        let localTime = moment(date).format("DD/MM/YYYY h:mm a");
        return <span>{localTime}</span>;
      },
    },
    {
      key: "consecutiveShipping",
      dataIndex: "orderTable",
      title: "Envío",
      className: "table-column",
      align: "center",
      render: (record) => <span>{record?.consecutiveShipping}</span>,
    },
  ];

  const linesColumns = [
    {
      key: "productNumber",
      dataIndex: "productNumber",
      title: "Código",
      className: "table-column",
      align: "center",
    },
    {
      key: "productName",
      dataIndex: "productName",
      className: "table-column",
      title: "Nombre",
    },
    {
      key: "initialQuantity",
      dataIndex: "initialQuantity",
      title: "Cantidad",
      className: "table-column",
      align: "right",
    },
    {
      key: "summationQuantity",
      dataIndex: "summationQuantity",
      title: "Entregado",
      className: "table-column",
      align: "right",
    },
  ];

  // Total header claro según dataset visible
  const totalHeader =
    filterRoutesBatch?.length > 0
      ? countFilterRouteComplete
      : filterRoutesBatchDetails?.length > 0
      ? countFilterRouteCompleteDetails
      : dataCompletedRoutes?.data?.routesBatch_aggregate?.aggregate?.count || 0;

  return (
    <Col className="children-inner-container-with-bg">
      <Row>
        <div className="SuperSearch">
          <div className="Search">
            <TextField
              onChange={textFieldEventPlanificador}
              size="small"
              label="Buscar Planificador"
              color="error"
              value={searchFilterPlanificador || ""}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton>
                      {loading ? (
                        <CircularProgress size={10} color="error" />
                      ) : (
                        <Search
                          onClick={() =>
                            handlsavePlanificador(
                              searchFilterPlanificador,
                              30,
                              0
                            )
                          }
                        />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div className="Search">
            <TextField
              onChange={textFieldEventConsecutivo}
              size="small"
              label="Buscar Consecutivo UM"
              color="error"
              value={searchFilterConsecutivo}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton>
                      {loading ? (
                        <CircularProgress size={10} color="error" />
                      ) : (
                        <Search
                          onClick={() =>
                            handlsaveConsecutivo(searchFilterConsecutivo, 30, 0)
                          }
                        />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div className="Search">
            <TextField
              onChange={textFieldEventCarga}
              size="small"
              label="Buscar Factura"
              color="error"
              value={searchFilterCarga}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton>
                      {loading ? (
                        <CircularProgress size={10} color="error" />
                      ) : (
                        <Search
                          onClick={() =>
                            handlsaveCarga(searchFilterCarga, 30, 0)
                          }
                        />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div className="Search">
            <TextField
              onChange={textFieldEventOVTRN}
              size="small"
              label="Buscar OV/TRN"
              color="error"
              value={searchFilterOVTRN}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton>
                      {loading ? (
                        <CircularProgress size={10} color="error" />
                      ) : (
                        <Search
                          onClick={() =>
                            handlsaveOVTRN(searchFilterOVTRN, 30, 0)
                          }
                        />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
        </div>
      </Row>

      <Row>
        <Col span={8}>
          <Skeleton loading={dataCompletedRoutesNumber.loading} active>
            <Table
              className={
                tableResponsive ? "children-table-3" : "children-table-100"
              }
              loading={loading}
              columns={headerColumns}
              dataSource={
                routesBatch?.length > 0
                  ? routesBatch
                  : filterRoutesBatch?.length > 0
                  ? filterRoutesBatch
                  : filterRoutesBatchDetails
              }
              rowKey="batch"
              pagination={false}
              rowSelection={{
                type: "radio",
                selectedRowKeys: selectedBatchKey ? [selectedBatchKey] : [],
                ...rowSelectionHeader,
              }}
            />
            <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={totalHeader}
              onChange={handlePageChange}
            />
          </Skeleton>
        </Col>

        <Col span={8}>
          <Skeleton loading={dataCompletedRoutesNumber.loading} active>
            <Table
              className={
                tableResponsive ? "children-table-3" : "children-table-100"
              }
              columns={detailsColumns}
              dataSource={details?.length > 0 ? details : filterDetails}
              pagination={false}
              rowKey="id"
              rowSelection={{ type: "radio", ...rowSelectionDetails }}
            />
            <Pagination
              current={currentPageSecond}
              pageSize={pageSizeSecond}
              total={details?.length || filterDetails?.length || 0}
              onChange={handlePageChangeSecond}
            />
          </Skeleton>
        </Col>

        <Col span={8}>
          <Row>
            <Skeleton loading={dataCompletedRoutesNumber.loading} active>
              <Table
                className={
                  tableResponsive ? "children-table-3" : "children-table-100"
                }
                columns={linesColumns}
                dataSource={lines}
                pagination={false}
                rowKey="id"
              />
              <Pagination
                current={currentPageTree}
                pageSize={pageSizeTree}
                total={lines?.length || 0}
                onChange={handlePageChangeTree}
              />
            </Skeleton>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col span={12}>
          <Row>
            {selectedOrderTable?.evidences?.length > 0 && (
              <Col span={24}>
                <h2>Evidencias</h2>
                <div>
                  <h4>
                    Comentarios: {selectedOrderTable.evidences[0].comments}
                  </h4>
                </div>
              </Col>
            )}
          </Row>
          <Row>
            <Col
              span={24}
              style={{
                display: "inline-flex",
                overflowX: "scroll",
                height: "auto",
                maxWidth: "100%",
                width: "100%",
              }}
            >
              {selectedOrderTable?.evidences?.map((item, index) => (
                <span key={`span-${index}`} style={{ padding: "3px" }}>
                  <Card
                    key={`card-${index}`}
                    hoverable
                    style={{ width: "300px", minWidth: "300px" }}
                    cover={
                      <Image
                        style={{
                          borderRadius: "10px 10px 0 0",
                          objectFit:
                            item.evidenceType === "FIRMA" ? "contain" : "cover",
                        }}
                        key={`image-${index}`}
                        width={300}
                        height={300}
                        src={item.evidenceURL}
                      />
                    }
                  >
                    <Card.Meta
                      key={`cardmeta-${index}`}
                      description={item.evidenceType}
                    />
                  </Card>
                </span>
              ))}
            </Col>
          </Row>
        </Col>

        {visibleTelemetry ? (
          <Col offset={1} span={11}>
            <Row>
              <Col span={24}>
                <h2>Ruta realizada</h2>
                <div>
                  <h4>{telemetry()}</h4>
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <DeliveryRoute
                  dataTelemetry={dataTelemetry}
                  visibleTelemetry={visibleTelemetry}
                  polylines={polylines}
                />
              </Col>
            </Row>
          </Col>
        ) : null}
      </Row>
    </Col>
  );
};
